import {useEffect, useState} from "react";
import {Card, Col, Row, Statistic} from "antd";
import {CameraOutlined, DollarCircleOutlined, ShoppingCartOutlined} from "@ant-design/icons";
import FlexCurrency from "../../../../utils/FlexCurrency";
import Api from "../../../../services/Api";

const GISE_HEX = {1: "#1677ff", 2: "#722ed1"};

const HomeFotoKapanComponent = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        Api.get("/api/FotoKapan/GetBugunKazanclar")
            .then(res => setData(res.data))
            .catch(err => console.error("Veri alınırken hata oluştu:", err));
    }, []);

    const s1 = data?.istasyon1;
    const s2 = data?.istasyon2;

    const toplamCekim  = s1?.shots  ?? 0;
    const toplamSatis  = s1?.sales  ?? 0;
    const toplamTutar  = (s1?.amount ?? 0) + (s2?.amount ?? 0);

    return (
        <Card title={"Foto Kapan"} bordered={false} loading={!data}>
            {/* Gişe tutarları */}
            <Row gutter={[16, 16]} style={{textAlign: "center", marginBottom: 16}}>
                <Col span={12}>
                    <Card
                        size={"small"}
                        style={{borderTop: `3px solid ${GISE_HEX[1]}`}}
                    >
                        <Statistic
                            title={<span style={{color: GISE_HEX[1], fontWeight: 600}}>1. Gişe</span>}
                            value={s1?.amount ?? 0}
                            suffix="₺"
                            valueStyle={{fontSize: 15, color: GISE_HEX[1]}}
                            formatter={v => FlexCurrency(Number(v))}
                        />
                    </Card>
                </Col>
                <Col span={12}>
                    <Card
                        size={"small"}
                        style={{borderTop: `3px solid ${GISE_HEX[2]}`}}
                    >
                        <Statistic
                            title={<span style={{color: GISE_HEX[2], fontWeight: 600}}>2. Gişe</span>}
                            value={s2?.amount ?? 0}
                            suffix="₺"
                            valueStyle={{fontSize: 15, color: GISE_HEX[2]}}
                            formatter={v => FlexCurrency(Number(v))}
                        />
                    </Card>
                </Col>
            </Row>

            {/* Toplam istatistikler */}
            <Row gutter={[16, 8]} style={{textAlign: "center"}}>
                <Col span={8}>
                    <CameraOutlined style={{fontSize: 22, color: "#1890ff"}}/>
                    <Statistic
                        title="Toplam Çekim"
                        value={toplamCekim}
                        valueStyle={{fontSize: 14}}
                        formatter={v => Number(v).toLocaleString("tr-TR")}
                        style={{marginTop: 4}}
                    />
                </Col>
                <Col span={8}>
                    <ShoppingCartOutlined style={{fontSize: 22, color: "#52c41a"}}/>
                    <Statistic
                        title="Satış Adeti"
                        value={toplamSatis}
                        valueStyle={{fontSize: 14}}
                        formatter={v => Number(v).toLocaleString("tr-TR")}
                        style={{marginTop: 4}}
                    />
                </Col>
                <Col span={8}>
                    <DollarCircleOutlined style={{fontSize: 22, color: "#fa541c"}}/>
                    <Statistic
                        title="Toplam Tutar"
                        value={toplamTutar}
                        suffix="₺"
                        valueStyle={{fontSize: 14, color: "#fa541c", fontWeight: 700}}
                        formatter={v => FlexCurrency(Number(v))}
                        style={{marginTop: 4}}
                    />
                </Col>
            </Row>
        </Card>
    );
};

export default HomeFotoKapanComponent;
